export const enum ChatOptionEnum {
    CHAT_TYPE = 'chat-type'
}